// Product tiles: image swatches pick the "color" option; quick add opens a small dropdown with only the
// remaining options for that color, then adds to cart and opens the cart drawer.
if (!window.t4ProductTileBound) {
  window.t4ProductTileBound = true;

  const variantsFor = (tile) => {
    if (!tile._variants) {
      const data = tile.querySelector('[data-tile-variants]');
      tile._variants = data ? JSON.parse(data.textContent) : [];
    }
    return tile._variants;
  };

  // The option that drives the variant image: an option named like "Color", otherwise the option whose
  // values best predict the image. -1 when there is none.
  const imageOptionIndex = (variants, names) => {
    if (!variants.length || !variants[0].options) return -1;
    const byName = names.findIndex((name) => /colou?r|tip colou?r/i.test(name));
    if (byName > -1) return byName;

    let best = -1;
    let bestScore = 0;
    for (let index = 0; index < variants[0].options.length; index++) {
      const groups = new Map();
      variants.forEach((variant) => {
        if (!variant.image) return;
        const value = variant.options[index];
        if (!groups.has(value)) groups.set(value, new Map());
        const images = groups.get(value);
        images.set(variant.image, (images.get(variant.image) || 0) + 1);
      });
      if (groups.size < 2) continue;
      let matched = 0;
      let total = 0;
      groups.forEach((images) => {
        const counts = [...images.values()];
        matched += Math.max(...counts);
        total += counts.reduce((a, b) => a + b, 0);
      });
      const score = matched / total;
      if (score > bestScore) {
        bestScore = score;
        best = index;
      }
    }
    return bestScore >= 0.6 ? best : -1;
  };

  const formatMoney = (cents, format) => {
    const [whole, decimals] = (cents / 100).toFixed(2).split('.');
    const commas = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (format || '${{amount}}')
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, commas)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, `${whole.replace(/\B(?=(\d{3})+(?!\d))/g, '.')},${decimals}`)
      .replace(/\{\{\s*amount\s*\}\}/, `${commas}.${decimals}`);
  };

  const state = (tile) => {
    if (!tile._state) {
      const variants = variantsFor(tile);
      const add = tile.querySelector('[data-tile-add]');
      const current = variants.find((v) => String(v.id) === add?.dataset.variantId) || variants[0];
      const names = (tile.dataset.optionNames || '').split('|');
      const index = imageOptionIndex(variants, names);
      tile._state = { index, value: current && index > -1 ? current.options[index] : null };
    }
    return tile._state;
  };

  const showVariant = (tile, variant) => {
    const format = tile.dataset.moneyFormat;
    const image = tile.querySelector('[data-tile-image]');
    if (image && variant.image) {
      image.removeAttribute('srcset');
      image.src = variant.image;
    }
    const price = tile.querySelector('[data-tile-price]');
    if (price) price.textContent = formatMoney(variant.price, format);
    const compare = tile.querySelector('[data-tile-compare]');
    if (compare) {
      compare.hidden = !(variant.compare > variant.price);
      compare.textContent = formatMoney(variant.compare, format);
    }
  };

  const selectSwatch = (swatch) => {
    const tile = tileFrom(swatch);
    const variants = variantsFor(tile);
    const variant = variants.find((v) => String(v.id) === swatch.dataset.variantId);
    if (!variant) return;
    const s = state(tile);
    if (s.index > -1) s.value = variant.options[s.index];

    // Prefer an available variant in the chosen color for the price shown.
    const inColor = variants.filter((v) => s.index < 0 || v.options[s.index] === s.value);
    showVariant(tile, inColor.find((v) => v.available) || variant);

    tile.querySelectorAll('[data-tile-swatch]').forEach((other) => {
      const active = other === swatch;
      other.classList.toggle('is-active', active);
      other.setAttribute('aria-pressed', active);
    });
    closePopover(tile);
  };

  const popoverFor = (tile) => {
    if (!tile._popover) tile._popover = tile.querySelector('[data-tile-popover]');
    if (tile._popover) tile._popover._tile = tile;
    return tile._popover;
  };

  const tileFrom = (element) =>
    element.closest('[data-product-tile]') || element.closest('[data-tile-popover]')?._tile;

  const isMobile = () => window.matchMedia('(max-width: 749px)').matches;

  let sheetHost;
  const sheetContainer = () => {
    if (!sheetHost) {
      sheetHost = document.createElement('div');
      sheetHost.className = 't4-section t4-sheet-host';
      document.body.appendChild(sheetHost);
    }
    return sheetHost;
  };

  const closePopover = (tile) => {
    const popover = tile && popoverFor(tile);
    if (!popover || popover.hidden) return;
    popover.hidden = true;
    if (popover.classList.contains('is-sheet')) {
      popover.classList.remove('is-sheet');
      tile.querySelector('[data-tile-actions]').appendChild(popover);
      document.documentElement.classList.remove('t4-sheet-open');
    }
    tile.querySelector('[data-tile-add]').setAttribute('aria-expanded', 'false');
  };

  const closeAll = (except) => {
    document.querySelectorAll('[data-product-tile]').forEach((tile) => {
      if (tile !== except) closePopover(tile);
    });
  };

  const openPopover = (tile) => {
    const variants = variantsFor(tile);
    const s = state(tile);
    const format = tile.dataset.moneyFormat;
    const popover = popoverFor(tile);
    const list = popover.querySelector('[data-tile-options]');
    const add = tile.querySelector('[data-tile-add]');
    const names = (tile.dataset.optionNames || '').split('|').filter((_, i) => i !== s.index);
    const options = variants.filter((v) => s.index < 0 || v.options[s.index] === s.value);

    popover.querySelector('[data-tile-popover-title]').textContent = add.dataset.labelSelect.replace('[options]', names.join(' & '));
    popover.querySelector('[data-tile-popover-sub]').textContent = s.index > -1 ? s.value : '';

    list.innerHTML = '';
    options.forEach((variant) => {
      const label = s.index > -1 ? variant.options.filter((_, i) => i !== s.index).join(' / ') : variant.title;
      const item = document.createElement('li');
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'product-tile__option';
      button.dataset.tileOption = variant.id;
      button.disabled = !variant.available;
      button.innerHTML = '<span class="product-tile__option-label"></span><span class="product-tile__option-price"></span>';
      button.querySelector('.product-tile__option-label').textContent = label || variant.title;
      button.querySelector('.product-tile__option-price').textContent = variant.available
        ? formatMoney(variant.price, format)
        : add.dataset.labelSoldOut;
      item.appendChild(button);
      list.appendChild(item);
    });

    // Only one choice for this color: add it straight away.
    if (options.length === 1 && options[0].available) {
      addToCart(tile, options[0].id);
      return;
    }

    closeAll(tile);
    if (isMobile()) {
      popover.classList.add('is-sheet');
      sheetContainer().appendChild(popover);
      document.documentElement.classList.add('t4-sheet-open');
    }
    popover.hidden = false;
    add.setAttribute('aria-expanded', 'true');
    list.querySelector('button:not([disabled])')?.focus({ preventScroll: true });
  };

  const openCartDrawer = async () => {
    const rebuy = window.Rebuy;
    try {
      if (rebuy?.Cart?.fetchCart) await rebuy.Cart.fetchCart();
      if (rebuy?.SmartCart?.show) {
        rebuy.SmartCart.show();
        return;
      }
    } catch (error) {
      // fall through to the theme cart
    }
    const drawer = document.querySelector('cart-drawer');
    if (drawer?.open) {
      drawer.open();
      return;
    }
    window.location.href = window.routes?.cart_url || '/cart';
  };

  const refreshCartBubble = (sections) => {
    const html = sections && sections['cart-icon-bubble'];
    const bubble = document.getElementById('cart-icon-bubble');
    if (!html || !bubble) return;
    const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
    if (fresh) bubble.innerHTML = fresh.innerHTML;
  };

  const addToCart = async (tile, variantId) => {
    const button = tile.querySelector('[data-tile-add]');
    const label = button.querySelector('[data-tile-add-label]');
    const original = label.textContent;
    closePopover(tile);
    button.classList.add('is-loading');

    try {
      const response = await fetch(`${window.routes?.cart_add_url || '/cart/add'}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }], sections: 'cart-icon-bubble' }),
      });
      if (!response.ok) throw new Error('add failed');
      const data = await response.json();
      refreshCartBubble(data.sections);
      button.classList.add('is-added');
      label.textContent = button.dataset.labelAdded;
      document.dispatchEvent(new CustomEvent('t4:cart-added', { detail: data }));
      openCartDrawer();
    } catch (error) {
      label.textContent = button.dataset.labelError;
    } finally {
      button.classList.remove('is-loading');
      setTimeout(() => {
        button.classList.remove('is-added');
        label.textContent = original;
      }, 2200);
    }
  };

  document.addEventListener('click', (event) => {
    const swatch = event.target.closest('[data-tile-swatch]');
    if (swatch) {
      event.preventDefault();
      selectSwatch(swatch);
      return;
    }

    const option = event.target.closest('[data-tile-option]');
    if (option) {
      event.preventDefault();
      addToCart(tileFrom(option), option.dataset.tileOption);
      return;
    }

    const close = event.target.closest('[data-tile-close]');
    if (close) {
      event.preventDefault();
      const tile = tileFrom(close);
      closePopover(tile);
      tile?.querySelector('[data-tile-add]')?.focus();
      return;
    }

    const add = event.target.closest('[data-tile-add]');
    if (add) {
      event.preventDefault();
      const tile = add.closest('[data-product-tile]');
      if (add.dataset.single === 'true') {
        addToCart(tile, add.dataset.variantId);
      } else if (add.getAttribute('aria-expanded') === 'true') {
        closePopover(tile);
      } else {
        openPopover(tile);
      }
      return;
    }

    if (!event.target.closest('[data-tile-popover]')) closeAll();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const tile = event.target.closest && tileFrom(event.target);
    closeAll();
    tile?.querySelector('[data-tile-add]')?.focus();
  });
}
